export var builtinNativeClasses = {};
export var nativeClasses = {};
export var nativeClassLoaderNames = [];
